import { render, staticRenderFns } from "./UnsavedTagsModal.vue?vue&type=template&id=d5732f76&"
import script from "./UnsavedTagsModal.vue?vue&type=script&lang=js&"
export * from "./UnsavedTagsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports